// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1b038a78","455":"19824aab","977":"5194cae2"}[chunkId] + ".chunk.js";
};